import React, { useContext, useEffect, useState } from 'react';
import CardContainer from '../../../../components/redesign/CardContainer';
import { KpiData } from 'components/redesign/KpiTile/types';
import KpiGrid from '../../../../components/redesign/KpiGrid';
import KpiDefinitionData from 'service/KpiDefinitionData';
import { FilterContext } from 'components/FilterBar/FilterProvider';
import KpiTile from 'components/redesign/KpiTile';
import scenariosCreated from '../../../../v2/kpis/rgm/pricingai/valueCreation/scenariosCreated';
import marketsSupported from '../../../../v2/kpis/rgm/pricingai/valueCreation/marketsSupported';
import { useDynamicGraphQLQuery } from 'hooks/useDynamicGraphQLQuery';

interface ScoreCardProps {
  title: string;
  showInfoIcon?: boolean;
}
const ScoreCard: React.FC<ScoreCardProps> = ({
  title,
  showInfoIcon = true,
}) => {
  const { data, isLoading } = useDynamicGraphQLQuery(
    'getRGMPricingVCScorecard'
  );
  const [overviewConfig, setOverviewConfig] = useState<KpiData[]>([]);
  const { selectedProduct } = useContext(FilterContext);

  const generateScoreCardItems = (data: any) => {
    return [marketsSupported.handler(data), scenariosCreated.handler(data)];
  };

  useEffect(() => {
    if (data?.getRGMPricingVCScorecard?.data) {
      setOverviewConfig(
        generateScoreCardItems({ ...data?.getRGMPricingVCScorecard?.data })
      );
    }
  }, [data?.getRGMPricingVCScorecard?.data]);

  return (
    <CardContainer
      title={title}
      showInfoIcon={showInfoIcon}
      dataDefinitions={{
        sections:
          KpiDefinitionData[selectedProduct?.productId]?.valueCreation
            ?.summary ?? [],
      }}
      isAccordion={false}
      isLoading={isLoading}
    >
      <KpiGrid columnsDesktop={2} columnsTablet={2} columnsMobile={2}>
        {overviewConfig.map((item, index) => (
          <KpiTile key={index} data={item} />
        ))}
      </KpiGrid>
    </CardContainer>
  );
};

export default ScoreCard;
